import AdminApi from '../services/api';
import swal from 'sweetalert2';
import CONFIG_COMPANY from "../services/myConfig";
import Loc from "../services/localization";

/* init */

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {

    props: ['show'],

    data() {
        return {
            locale: LocService,
            isLoading: false,
            items: [],
            successAdd: '',
            hasError: '',
            query: '',
        };
    },

    watch: {
        show: function (val, oldVal) {
            if(val === true){

            }
        },
    },

    beforeMount() {
        this.load();
    },

    computed: {
        filteredItems() {
            return this.items.filter(item => {
                return item.name.toLowerCase().indexOf(this.query.toLowerCase().trim()) > -1;
            });
        }
    },

    methods: {
        close() {
            this.reset();
            this.$topnavbar.$emit('closeChooseShopItem')
        },
        chooseUser: chooseUser,
        keymonitor: keymonitor,
        reset: reset,
        load: load,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        getClassMobile() {
            if (this.isMobile()) {
                return 'modal--small'
            } else {
                return 'modal--large'
            }
        },
        modalStyle() {
            if (this.isMobile()) {
                return 'color: white; background-color: black;'
            } else {
                return ''
            }
        },
        mainDivStyle() {
            if (this.isMobile()) {
                return 'background-color: #1C242D; color: #ffffff;'
            } else {
                return 'background-color: #1C242D; color: #ffffff;'
            }
        },
        tableStyle() {
            if (this.isMobile()) {
                return 'height: 400px !important; overflow: auto; padding: 15px;';
            }
            return 'height: 600px !important; overflow: auto; padding: 15px;';
        }
    }
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.load();
    }
}

function load() {
    let _self = this;
    AdminApiService.getCompanyInfoShopItems()
        .then((response) => {
            _self.items = response.data;
        })
        .catch((error) => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function reset() {
    this.query = ''
}

function chooseUser(user) {
    if(this.mustSelectTrainerWhenReserveTraining === true && this.selectedPartners.length === 0){
        this.hasError = LocService.t('label_please_select_trainer');
        return;
    }
    this.reset();
    if(this.mustSelectTrainerWhenReserveTraining === true){
        user.selectedTrainer = this.selectedPartners[0]
    }
    this.$topnavbar.$emit('onShopItemSelected', user)
    this.successAdd = LocService.t('label_success_added_user') + ': ' + user.name + " " + user.surname;
}


// WEBPACK FOOTER //
// ./src/modals/ChooseShopItemModal.js